import {
  approveTimeEntriesMutation,
} from './graphql';
import { deleteTimeEntryMutationGQL } from './graphql/TimeEntryGQL';
import { sleep } from '../../utils';
import { getUser } from '../authentication/selectors';

import { approvePayPeriodSummarysApi } from './graphql/ApprovePayPeriodSummaryApi';
import { unapprovePayPeriodSummarysApi } from './graphql/UnapprovePayPeriodSummaryApi';

export const types = {
  SELECT_TIMESHEET_KEY: 'timesheet_approvals/SELECT_TIMESHEET_KEY',
  SELECT_SUPERVISOR_ID: 'timesheet_approvals/SELECT_SUPERVISOR_ID',
  SHOW_TIMEENTRY_MODAL: 'timesheet_approvals/SHOW_TIMEENTRY_MODAL',
  HIDE_TIMEENTRY_MODAL: 'timesheet_approvals/HIDE_TIMEENTRY_MODAL',
  SET_MODAL_API_ERROR_MESSAGE: 'timesheet_approvals/SET_MODAL_API_ERROR_MESSAGE',
  SHOW_GUARANTEED_TIME_MODAL: 'timesheet_approvals/SHOW_GUARANTEED_TIME_MODAL',
  HIDE_GUARANTEED_TIME_MODAL: 'timesheet_approvals/HIDE_GUARANTEED_TIME_MODAL',
  SET_DISABLE_APPROVEUNAPPROVE_BUTTON: 'timesheet_approvals/SET_DISABLE_APPROVEUNAPPROVE_BUTTON',
};

export const dispatchSelectTimesheetKey = (timesheetKey, timesheetIsApproved) => {
  return {
    type: types.SELECT_TIMESHEET_KEY,
    currentTimesheetKey: timesheetKey,
    currentTimesheetIsApproved: timesheetIsApproved,
  };
};

export const dispatchSelectSupervisor = (supervisorId) => {
  return {
    type: types.SELECT_SUPERVISOR_ID,
    currentSupervisorId: supervisorId,
  };
};

export const dispatchSetModalAPIErrorMessage = (errorMessage) => {
  return {
    type: types.SET_MODAL_API_ERROR_MESSAGE,
    modalAPIErrorMessage: errorMessage,
  };
};

export const dispatchShowGuaranteedTimeModal = (timesheet) => {
  return {
    type: types.SHOW_GUARANTEED_TIME_MODAL,
    maybeApprovedTimesheet: timesheet,
  };
};

export const dispatchHideGuaranteedTimeModal = () => {
  return {
    type: types.HIDE_GUARANTEED_TIME_MODAL,
  };
};

export const dispatchSetDisableApproveUnapproveButton = (timesheetId) => {
  return {
    type: types.SET_DISABLE_APPROVEUNAPPROVE_BUTTON,
    disableApproveUnapproveButtonForId: timesheetId,
  };
};

const dispatchApprovalMutation = async (
  client,
  userId,
  key,
  startOfWeek,
  secondsToAdd,
  supervisorId,
  payPeriodWeekId,
  userTimesheets,
) => {
  if (secondsToAdd > 0) {
    await approvePayPeriodSummarysApi(
      client,
      userId,
      startOfWeek,
      secondsToAdd,
      supervisorId,
      payPeriodWeekId,
      userTimesheets,
    );
  } else {
    await approveTimeEntriesMutation(
      client,
      userId,
      startOfWeek,
      key,
      secondsToAdd,
      supervisorId,
    );
  }
};

export const dispatchChangeApprovalState = (timesheet, forApproval, secondsToAdd, supervisorId) => {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch(dispatchSetDisableApproveUnapproveButton(timesheet.id));

      const {
        user,
        start_date,
        key,
        payPeriodWeek: { id: payPeriodWeekId },
        payPeriodSummary: { userTimesheets },
      } = timesheet;

      const startOfWeek = start_date.iso8601;

      if (forApproval) {
        dispatchApprovalMutation(
          client,
          user.id,
          key,
          startOfWeek,
          secondsToAdd,
          supervisorId,
          payPeriodWeekId,
          userTimesheets,
        );
      } else {
        unapprovePayPeriodSummarysApi(
          client,
          user.id,
          startOfWeek,
          supervisorId,
          payPeriodWeekId,
          userTimesheets,
        );
      }
      dispatch(dispatchHideGuaranteedTimeModal());
    } finally {
      dispatch(dispatchSelectTimesheetKey(null, null));

      // this sleep is to accomodate waiting for apollo to update the cache.
      await sleep(2000);
      dispatch(dispatchSetDisableApproveUnapproveButton(null));
    }
  };
};

export const dispatchShowCreateEditTimeEntryEditorModal = (
  timeEntry,
  minEditDate = null,
  maxEditDate = null,
) => {
  return {
    type: types.SHOW_TIMEENTRY_MODAL,
    showTimeEntryModal: true,
    currentTimeEntry: timeEntry,
    modalIsCreateEdit: true,
    minEditDate,
    maxEditDate,
  };
};

export const dispatchShowDeleteTimeEntryEditorModal = (timeEntry) => {
  return {
    type: types.SHOW_TIMEENTRY_MODAL,
    showTimeEntryModal: true,
    currentTimeEntry: timeEntry,
    modalIsCreateEdit: false,
  };
};

export const dispatchHideTimeEntryEditorModal = () => {
  return {
    type: types.HIDE_TIMEENTRY_MODAL,
    showTimeEntryModal: false,
  };
};

export const dispatchDeleteTimeEntry = (
  timeEntryId,
  timeEntryKey,
  supervisorId,
  userId,
  timesheetOriginDate,
) => {
  return async (dispatch, getState, { client }) => {
    try {
      await deleteTimeEntryMutationGQL(
        client,
        timeEntryId,
        timeEntryKey,
        supervisorId,
        userId,
        timesheetOriginDate,
      );

      dispatch(dispatchHideTimeEntryEditorModal());
    } catch (error) {
      if (error.graphQLErrors) {
        const errorMessage = error.graphQLErrors[0].message;
        dispatch(dispatchSetModalAPIErrorMessage(errorMessage));
      }
    }
  };
};

export const initPage = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const user = getUser(state);

    dispatch(dispatchSelectSupervisor(user.id));
  };
};
